import {useUserPropertyStore} from "../store/user-property";

class FeatureService {
  getIsFeatureEnabled(featureKey: string): boolean {
    const userProperty = useUserPropertyStore.getState().userProperty;
    if (!userProperty) return false;
    return userProperty.sections.find((section) => section.key === featureKey)?.granted === 1;
  }

  get isPermanentParkingEnabled(): boolean {
    return this.getIsFeatureEnabled("permanentparking");
  }

  get isSafelistingsEnabled(): boolean {
    return this.getIsFeatureEnabled("safelistings");
  }

  get isCitationsEnabled(): boolean {
    return this.getIsFeatureEnabled("citations");
  }

  get isStoredVehiclesEnabled(): boolean {
    return this.getIsFeatureEnabled("storedvehicles");
  }

  /** Vehicles / parking-enforcement section from property `sections` (`/me`-selected property). */
  get isVehiclesEnabled(): boolean {
    return this.getIsFeatureEnabled("vehicles");
  }
}

export const featureService = new FeatureService();
